// 🔹 Stylesheets
import './TrainingNavigationButton.component.css';

// 🔹 React Core
import React, { FC } from 'react';

// 🔹 UI Component Libraries
import { Button } from 'src/components/Button/Button.tsx';

// 🔹 Assets
import navigationArrow from 'url:../../assets/images/navigation-arrow.png';

interface TrainingNavigationButtonProps {
  currentStep: number;
  totalSteps: number;
  prevStep: (step: number) => void;
  nextStep: (step: number) => void;
  prevDisable: boolean;
  nextDisable: boolean;
}

const TrainingNavigationButton: FC<TrainingNavigationButtonProps> = ({
  currentStep,
  totalSteps = 5,
  prevStep,
  nextStep,
  prevDisable = false,
  nextDisable = false,
}) => {
  return (
    <div className={'trainer-card-footer'}>
      <div className={'navigationWrapper'}>
        <Button
          onClick={() => prevStep(currentStep - 1)}
          variant="outline"
          className={`navigationButton leftButton`}
          disabled={currentStep === 0 || prevDisable}
        >
          <img src={navigationArrow} alt="" />
        </Button>
        <div className={'navigationStep'}>
          {Array.from({ length: totalSteps }, (_, step) => (
            <div
              key={step}
              className={`
      ${step === currentStep ? 'navigationStepActive' : ''}
      ${step < currentStep ? 'navigationStepDotActive' : ''}
      navigationStepItem
    `}
            ></div>
          ))}
        </div>
        <Button
          onClick={() => nextStep(currentStep + 1)}
          variant="outline"
          className={`navigationButton rightButton`}
          disabled={nextDisable}
        >
          <img src={navigationArrow} alt="" />
        </Button>
      </div>
    </div>
  );
};

export default TrainingNavigationButton;
